module.exports = __webpack_public_path__ + "img/9788952751577.8bb34183.jpg";